import React, { useState, useEffect } from "react";
import NavBar from "./NavBar";
import SideBar from "./SideBar";
import { useSearchParams, useParams } from "react-router-dom";
import clinicService from "../../services/clinic.service";
import WelcomeForm from "./WelcomeForm";
import PageLoading from "../common/PageLoading";
const WelcomePage = () => {
  let { clinicId } = useParams();
  const [searchParams] = useSearchParams();
  const [clinic, setClinic] = useState();
  const [patientID, setPatientID] = useState(0);
  const [patientUUID, setPatientUUID] = useState("0");
  const [contactPref, setContactPref] = useState();
  const [utype, setUtype] = useState(0);
  const [udata, setUdata] = useState();


  useEffect(() => {
    setPatientID(searchParams.get("p"));
    setPatientUUID(searchParams.get("u"));
    setUtype(searchParams.get("type"));
    setUdata(searchParams.get("data"));
    //console.log("sending api requiest");
    const pid = searchParams.get("p");
    const uid = searchParams.get("u");
    const urlType = searchParams.get("type");
    const urlData = searchParams.get("data");

    clinicService
      .getClinicByShortCode(clinicId)
      .then((res) => {
        setClinic(res.data);
        //console.log(res.data);
        clinicService
          .getPatientPref(res.data.ID, pid, uid, urlType, urlData)
          .then((cres) => {
            //console.log(cres);
            setContactPref(cres.data);
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.log(err);
      });
   // console.log("sending api request");
  }, []);

  return (
    <>
      {clinic && (
        <div>
          <NavBar clinic={clinic} />
          <div className="container">
            <div className="row">
              <div className="col-lg-9 order-lg-last">
                {contactPref ? (
                  <WelcomeForm preferences={contactPref} clinicId={clinic.ID} pid={patientID} puid={patientUUID} utype={utype} udata={udata} />
                ) : (
                  <PageLoading />
                )}
              </div>
              <div className="col-lg-3">
                <SideBar clinic={clinic} />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default WelcomePage;
